import React from "react"
import styled from "styled-components"

import map from "lodash/map"

import { PostAuthor } from "."

const PostAuthors = ({ authors, date }) => {
  const horizontal = authors.length > 1

  const renderAuthors = () =>
    map(authors, (author) => (
      <PostAuthor
        key={author.id}
        author={author}
        date={date}
        horizontal={horizontal}
      />
    ))

  return <Authors className="authors">{renderAuthors()}</Authors>
}

const Authors = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: var(--sp-8);
`

export default PostAuthors
